// extracted by mini-css-extract-plugin
export default {"textWrapper":"styles_textWrapper__bo3lY"};